export {default as Example} from '../modules/exemple'
export {default as Slider} from '../modules/slider'
export {default as Video} from '../modules/video'
export {default as VideoPopin} from '../modules/videoPopin'
export {default as SimpleMap} from '../modules/simpleMap'
export {default as dotSlider} from '../modules/dotSlider'
export {default as filtersCompanies} from '../modules/filtersCompanies'
export {default as lexique} from '../modules/lexique'
export {default as repeaterFaq} from '../modules/repeaterFAQ'
export {default as secondaryNav} from '../modules/secondaryNav'
export {default as NewsSlider} from '../modules/newsSlider'
export {default as Marquee} from '../utils/effects/marquee'
export {default as Newsletter} from '../modules/newsletter'
export {default as Numbers} from '../modules/numbers'
export {default as Header} from '../modules/header'
export {default as TextAppear} from '../modules/textAppear'
export {default as ImgAppear} from '../modules/imgAppear'
export {default as loadMore} from '../modules/loadMore'



// WEBPACK FOOTER //
// ./scripts/core/bulbModulesList.js